import { ImpersonateServiceInterface } from 'domain/services';
import { ImpersonatePersonUseCaseInterface } from 'domain/usecases';

interface UseCasesInjection {
  impersonatePerson: ImpersonatePersonUseCaseInterface;
}

export class ImpersonateService implements ImpersonateServiceInterface {
  private readonly _impersonatePersonUseCase: ImpersonatePersonUseCaseInterface;

  constructor(usecases: UseCasesInjection) {
    this._impersonatePersonUseCase = usecases.impersonatePerson;
  }

  impersonatePerson(
    params: ImpersonatePersonUseCaseInterface.Params,
  ): Promise<ImpersonatePersonUseCaseInterface.Result> {
    return this._impersonatePersonUseCase.execute(params);
  }
}
